import React, { useEffect, useState } from 'react';
import { Col, Dropdown, Form } from 'react-bootstrap';
import { secToHourMin, downloadFile } from '../../../utils/utils'
import { VideoIcon, FolderOpenIcon } from '../../../utils/FontIcon';
import { publish } from '../../../utils/pubsubWrapper';
import { useLesson } from '../../../context/LessonContext';
import { useLogin } from '../../../context/LoginContext';
import { SuccessIcon, ErrorIcon } from '../../../utils/FontIcon';

function Resources({ videoRef }) {
    return (
        <Dropdown style={{ marginTop: '.25rem' }} title='Resources'>
            <Dropdown.Toggle
                as="span"
                style={{
                    border: 'solid 1px #3e80c7',
                    boxShadow: 'none',
                    padding: '4px 16px',
                    cursor: 'pointer',
                    borderRadius: '5px',
                    color: '#3e80c7',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                <FolderOpenIcon style={{ fontSize: '14px', marginRight: '.25rem' }} />Resources
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {videoRef.map((document, index) => (
                    <Dropdown.Item
                        key={index}
                        onClick={e => {
                            e.preventDefault();
                            e.stopPropagation(); // Prevents parent Col click
                            downloadFile(document.documentUrl, document.title);
                        }}
                    >
                        {`${index + 1}. ${document.title}`}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
}
const LessonCard = ({ lesson, idx,isDisabled }) => {
    // console.log("🚀 krishna  ~ isDisabled:", isDisabled);

    const { user } = useLogin();
    const { courseDetail, activeIdx, changeActiveLesson } = useLesson();
    const videoRef = lesson?.refDetails?.referenceDocuments || [];
    const maxLength = 50;
    const description = lesson?.refDetails?.description ? lesson?.refDetails?.description : 'No description available.'
    const isMax = description.length > maxLength;
    const displayText = isMax ? description.slice(0, maxLength) + '...' : description;
    const [shouldChecked, setShouldChecked] = useState(false);
    const [showCheckbox, setShowCheckbox] = useState(false);
    useEffect(() => {
        if (user?.selectedRole === 'approver') {
            if (courseDetail.status === 'draft' || courseDetail.status === 'rejected') {
                setShowCheckbox(true);
                setShouldChecked(true);
            } else {
                setShowCheckbox(false);
                setShouldChecked(false);
            }
        }
        else if (user?.selectedRole === 'viewer') {
            setShowCheckbox(true);
            if (lesson?.status === "completed") {
                setShouldChecked(true);
            }
        } else {
            setShowCheckbox(false);
            setShouldChecked(false);
        }
    }, [lesson, user?.selectedRole]);
    const handleClick = (e) => {
        e.stopPropagation();
        changeActiveLesson(idx);
    };
    const handleCheckBoxChange = (e) => {
        const { checked } = e.target;
        setShouldChecked(checked);
        publish('UPDATE_REMOVE_LESSON', { checked, lesson });
    };

    const checkBox = (user?.selectedRole === 'viewer' ? lesson?.status === "completed" ?
        <span>
            <SuccessIcon style={{ color: '#28a745', fontSize: '20px', marginTop: '4px' }} />
        </span> : <span><ErrorIcon style={{ color: 'rgba(0, 0, 0,0)', fontSize: '20px', marginTop: '4px' }} /></span> : <span>
        <Form.Check
            type="checkbox"
            checked={shouldChecked}
            style={{ marginTop: '4px' }}
            onChange={handleCheckBoxChange}
        />
    </span>)


    return (
        <Col xs={12}>
            <div className={`text-start ${isDisabled ? 'disable-lessonlist' : 'course-lessons'} ${activeIdx === idx ? ' active' : ''}`} style={{ position: 'relative' }}>
                {lesson.type === 'quiz' ? (
                    <>
                        {showCheckbox ? checkBox : null}
                        <span>{idx + 1}</span>
                        <span>
                            <div onClick={isDisabled ? undefined : handleClick}>
                                <span className='fw-600 d-block'>{`Quiz: ${lesson?.refDetails?.title}`}</span>
                                <small className='d-block text-muted'>{displayText}</small>
                            </div>
                        </span>
                    </>
                ) : (
                    <>
                        {showCheckbox ? checkBox : null}
                        <span>{idx + 1}</span>
                        <span>
                            <div onClick={handleClick}>
                                <span className='fw-600 d-block'>{lesson?.refDetails?.title}</span>
                                <small className='d-block text-muted'>{displayText}</small>
                            </div>
                            <small className='duration-txt'>
                                <span>
                                    <VideoIcon style={{ fontSize: '14px', marginRight: '5px' }} />
                                    {`${secToHourMin(lesson?.refDetails?.duration)}`}
                                </span>
                                {videoRef.length ? <Resources videoRef={videoRef} /> : null}
                            </small>
                        </span>
                    </>
                )}
            </div>
        </Col>
    );
}

export default LessonCard;